import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StepComponent } from './step.component';
import { FieldsetModule } from '../fieldset/fieldset.module';



@NgModule({
  declarations: [StepComponent],
  imports: [
    CommonModule,
    FieldsetModule
  ],
  exports: [StepComponent]
})
export class StepModule { }
